import { Flex } from 'antd';
import { FC, memo } from 'react';

import { AppModalControlProps } from '@/common/interfaces';

import { Redirect } from '@/modules/Sites/Redirects';

import { RedirectsManageDeleteModal, RedirectsManageTable, RedirectsManageToolbar } from './components';

interface Props {
  list: Redirect[];
  totalCount: number;
  currentPage: number;
  itemsPerPage: number;
  isBusy: boolean;
  isUpdatingActivity: boolean;
  isDeleting: boolean;
  deleteModalControls: AppModalControlProps;
  isFetching: boolean;
  selectedIds: string[];
  onChangePage: (page: number) => void;
  onChangeSelectedIds: (ids: string[]) => void;
  onSetActivity: (isActive: boolean) => void;
  onConfirmDelete: () => void;
}

export const RedirectsBulkManageView: FC<Props> = memo(({
  list,
  totalCount,
  currentPage,
  itemsPerPage,
  onChangePage,
  isFetching,
  selectedIds,
  onChangeSelectedIds,
  isBusy,
  isUpdatingActivity,
  isDeleting,
  deleteModalControls,
  onSetActivity,
  onConfirmDelete,
}) => {
  return (
    <Flex vertical gap={ 12 }>
      <RedirectsManageToolbar
        selectedCount={ selectedIds.length }
        totalCount={ totalCount }
        isBusy={ isBusy }
        isUpdatingActivity={ isUpdatingActivity }
        onSetActivity={ onSetActivity }
        onOpenDeleteModal={ deleteModalControls.open }
      />

      <RedirectsManageTable
        list={ list }
        totalCount={ totalCount }
        currentPage={ currentPage }
        itemsPerPage={ itemsPerPage }
        onChangePage={ onChangePage }
        isFetching={ isFetching }
        selectedIds={ selectedIds }
        onChangeSelectedIds={ onChangeSelectedIds }
        disabled={ isBusy }
      />

      <RedirectsManageDeleteModal
        controls={ deleteModalControls }
        count={ selectedIds.length }
        isDeleting={ isDeleting }
        onConfirm={ onConfirmDelete }
      />
    </Flex>
  );
});
